import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import Header from '../headerone/Main'
import Breadcrumb from '../Breadcrumb/Main'
import { Container, Row, Col, Table } from "react-bootstrap";

const teachers = [
    {
        name: "श्री उमेश कुमार सिंह ",
        namelink: "#",
        position1: "सहायक कुलसचिव / राजभाषा अधिकारी",
        email: "umesh@iittp.ac.in",
        phoneno: "0877 250 3535",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/umeshkumarsingh.png"
    },
    {
        name: "श्रीमती सी विजयलक्ष्मी ",
        namelink: "#",
        position1: "हिन्दी कनसल्टेंट",
        email: " vijayalakshmi@iittp.ac.in",
        phoneno: " ",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/Vijayalakshmi.jpeg"
    },   
        
]

const Hindi = [
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img1.JPG" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img2.JPG" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img3.JPG" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img4.JPG" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img20.jpeg" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img21.jpeg" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img5.JPG" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img6.JPG" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img7.JPG" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img8.JPG" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img9.JPG" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img10.JPG" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img11.JPG" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img12.JPG" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img13.JPG" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img14.JPG" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img15.JPG" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img16.JPG" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img17.JPG" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img18.JPG" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img19.JPG" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img22.jpeg" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img23.jpeg" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/img24.jpeg" }

    
]


const Gallery = [

    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/pic1.jpeg" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/Pic9.jpeg" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/Pic3.jpeg" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/Pic2.jpeg" },
    
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/Pic4.jpeg" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/Pic5.jpeg" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/Pic6.jpeg" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/Pic7.jpeg" },
    
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/Pic10.jpeg" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/pic11.jpeg" },
    { img: "https://files.iittp.ac.in/images/demo/iit/hindi-cell/pic12.jpeg" }
 
]


function Main() {
    

    const [activeIndex, setActiveIndex] = useState(0);

    const handleToggle = (index) => {
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    };
    const faqData = [
        
        {
            id: 'headingOne',
            question: 'वैधानिक उपाय',
            answer: '',
        },
        {
            id: 'headingTwo',
            question: 'राजभाषा विभाग द्वारा निर्धारित निदेशों/लक्ष्यों के अनुसार अन्य कार्य समयबद्ध तरीके से किए जा रहे हैं',
            answer: '',
        },
        {
            id: 'headingThree',
            question: 'राजभाषा नीति के कार्यान्वयन के लिए अनुकूल वातावरण बनाने के लिए प्रस्तावित अन्य उपाय',
            answer: '',
        },
        {
            id: 'headingFour',
            question: 'सन्देश',
            answer: '',
        },
        {
            id: 'headingFive',
            question: 'संस्थान की राजभाषा प्रकोष्ठ की तिमाही रिपोर्ट',
            answer: '',
        },
        {
            id: 'headingSix',
            question: 'राजभाषा कार्यान्वयन समिति',
            answer: '',
        },
        {
            id: 'headingSeven',
            question: 'बैठकों के कार्यवृत्त',
            answer: '',
        },
        {
            id: 'headingEight',
            question: 'हिंदी गतिविधियाँ',
            answer: '',
        },
        {
            id: 'headingNine',
            question: 'राजभाषा नीति',
            answer: '',
        },
        {
            id: 'headingTen',
            question: 'वार्षिक कार्यक्रम',
            answer: '',
        },
        {
            id: 'headingEleven',
            question: 'सुविचार',
            answer: '',
        },
        {
            id: 'headingTwelev',
            question: 'गैलरी',
            answer: '',
        },
        {
            id: 'headingThirteen',
            question: 'हिन्दी के प्रयोग संबंधी आदेशों का संकलन',
            answer: '',
        },
        
        
    ];

       
    return(
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="RAJBHASHA"/>
            <section className="project-detail rajbhasha">
                <div className='container'>
                    <div className="c-heading">  
                        <h1>राजभाषा प्रकोष्ठ </h1>
                        <h1>Rajbhasha Prakoshth</h1>
                    </div>
                    <div>
                    <h4>सदस्य:</h4> 
                    <div className="row">
                        {teachers.map((teacher, index) => (
                           <div key={index} className="col-xl-4 col-md-6 col-sm-6">
                                <div className="single-team mb-40">
                                    <div className="team-thumb">
                                        <div className="brd">
                                            <Link to="/team-single">
                                                <img src={teacher.image} alt="img" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="team-info">
                                        <h4>
                                            <Link to={teacher.namelink}>{teacher.name}</Link>
                                        </h4>
                                        <div className="text-dark">
                                        <p className='fw-bold' >{teacher.position1}</p>
                                           
                                            {/* <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{teacher.phoneno}</p> */}
                                            {/* <p className="text-orange"><i className="fal fa-envelope  me-2"></i> <Link to={teacher.email} target="_blank" className="btn btn-primary">{teacher.email}</Link></p> */}
                                            {/* <p className="text-dark"><i className="fal fa-envelope  me-2"></i>{teacher.email}</p> */}
                                        </div>
                                        <div className="team-social">
                                            {/* <ul>
                                                {teacher.social.map((platform, index) => (
                                                    <li key={index}>
                                                        <Link to={platform.link}>
                                                            {platform.platform === 'facebook' && <i className="fab fa-facebook-f" />}
                                                            {platform.platform === 'instagram' && <i className="fab fa-instagram" />}
                                                            {platform.platform === 'twitter' && <i className="fab fa-twitter" />}
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="c-heading">  
                        <h3>राजभाषा नीति @ आई आई टी तिरुपति </h3>
                       
                    </div>
                    <div>
                      <h4>पृष्ठभूमि:</h4> 
                      <p className="caboutus">भारतीय प्रौद्योगिकी संस्थान तिरुपति (आईआईटी तिरुपति), प्रौद्योगिकी संस्थान अधिनियम, 1961 के तहत निगमीकृत किया गया है तथा प्रौद्योगिकी संस्थान (संशोधित) अधिनियम, 2016 की धारा 2 के तहत भारत सरकार के शिक्षा मंत्रालय के अधीन कार्यरत राष्ट्रीय महत्व का एक संस्थान है। इसने शैक्षणिक वर्ष 2015-16 से अपना कार्य करना प्रारंभ कर दिया है।</p> 
                      <h4>संस्थान में भारत सरकार की राजभाषा नीति के अनुपालन में निम्नलिखित उपाय किए जाते हैं:</h4> 
                      <p className="caboutus">कुछ उपाय वैधानिक प्रकृति के हैं, कुछ गृह मंत्रालय, राजभाषा विभाग द्वारा निर्धारित निर्देशों/लक्ष्यों के पालन से संबंधित हैं, जबकि हिंदी के प्रयोग को बढ़ावा देने के लिए एक अनुकूल वातावरण बनाने के लिए कुछ कदम उठाए जा रहे हैं।</p> 
                    
                    </div>
                    </div>
                    <Row>
                    <div className="col-lg-12 col-md-12  wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s" >
                            <div className="faq-wrap pl-30 wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                                <div className="accordion" id="accordionExample">
                                    
                                        {/* Index0 ---------------------- start */}
                                        <div className="card">
                                            <div className="card-header">
                                                <h2 className="mb-0">
                                                    <button  className={`faq-btn${activeIndex === 0 ? '' : ' collapsed'}`} type="button" data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse0`}
                                                        onClick={() => handleToggle(0)} >
                                                        <h4>वैधानिक उपाय</h4>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div id={`collapse0`}
                                                className={`collapse${activeIndex === 0 ? ' show' : ''}`} 
                                                data-bs-parent="#accordionExample">
                                                <div className="card-body">
                                                   
                                                    <ol className="list-group list-group-numbered"
                                        
                                        style={{ textAlign: 'justify', fontSize: '12pt' }}>
                                                    
                                                    <li>राजभाषा विभाग के निर्देशों के अनुसार राजभाषा कार्यान्वयन समिति का गठन किया गया है </li>
                                                    <li>समिति द्वारा निम्नलिखित उद्देश्यों से लिए गए निर्णयों पर अनुवर्ती कार्रवाई करने में 
                                                    
                                                    सहयोग देने के लिए एक हिंदी प्रकोष्ठ का गठन किया गया है:</li>
                                                    <ul className='myulcustarrow'>
                                                    <li>वार्षिक कार्यक्रम के तहत निर्धारित लक्ष्यों को प्राप्त करना</li>
                                                    <li>राजभाषा हिन्दी के प्रयोग में उत्तरोत्तर प्रगति सुनिश्चित करना और</li>
                                                    <li>राजभाषा नीति के कार्यान्वयन को सुगम बनाना।</li>
                                                    </ul>
                                                    
                                                    <li>वार्षिक रिपोर्ट, वार्षिक लेखा और इस किस्म के अन्य दस्तावेजों का अनुवाद</li>
                                                                                              
                                                 
                                                </ol>
                                                     
                                                </div>
                                            </div>
                                        </div>
                                        {/* Index0 ---------------------- end */}

                                        {/* Index1 ---------------------- start */}
                                        <div className="card">
                                            <div className="card-header">
                                                <h2 className="mb-0">
                                                    <button  className={`faq-btn${activeIndex === 1 ? '' : ' collapsed'}`} type="button" data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse1`}
                                                        onClick={() => handleToggle(1)} >
                                                        <h4>राजभाषा विभाग द्वारा निर्धारित निदेशों/लक्ष्यों के अनुसार अन्य कार्य समयबद्ध तरीके से किए जा रहे हैं</h4>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div id={`collapse1`}
                                                className={`collapse${activeIndex === 1 ? ' show' : ''}`} 
                                                data-bs-parent="#accordionExample">
                                                <div className="card-body">
                                                <ol className="list-group list-group-numbered"
                                        
                                        style={{ textAlign: 'justify', fontSize: '12pt' }}>
                                                    
                                                    <li>राजभाषा अधिनियम के प्रावधानों की जानकारी देने के लिए तथा कर्मचारियों को उनके कर्तव्य के बारे में संवेदनशील बनाने के लिए त्रैमासिक हिंदी कार्यशालाओं / संगोष्ठियों का आयोजन करना और सक्षम प्राधिकारी को समय पर आवधिक रिपोर्ट प्रस्तुत करना </li>
                                                    <li>हिंदी पखवाड़े का आयोजन</li>
                                                    <li>केंद्र सरकार के कार्यालयों के साथ हिंदी/द्विभाषी रूप में पत्राचार और निर्धारित के रूप में फाइल नोटिंग</li>
                                                    <li>ई-बुक्स, सीडी/ डीवीडी सहित पुस्तकालय के लिए हिंदी पुस्तकों की खरीद</li>
                                                                                              
                                                 
                                                </ol>

    
                                                </div>
                                            </div>
                                        </div>
                                        {/* Index1 ---------------------- end */}
                                        {/* Index2 -----------------------start*/}
                                        <div className="card">
                                            <div className="card-header">
                                                <h2 className="mb-0">
                                                    <button  className={`faq-btn${activeIndex === 2 ? '' : ' collapsed'}`} type="button" data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse2`}
                                                        onClick={() => handleToggle(2)} >
                                                        <h4>राजभाषा नीति के कार्यान्वयन के लिए अनुकूल वातावरण बनाने के लिए प्रस्तावित अन्य उपाय</h4>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div id={`collapse2`}
                                                className={`collapse${activeIndex === 2 ? ' show' : ''}`} 
                                                data-bs-parent="#accordionExample">
                                                <div className="card-body">
                                                <ol className="list-group list-group-numbered"
                                        
                                        style={{ textAlign: 'justify', fontSize: '12pt' }}>
                                                    
                                                    <li>संस्थान के सभी सदस्यों को प्रति दिन एक स्वागत संदेश भेजना जिसमें एक हिंदी शब्द उसके तेलुगु और अंग्रेजी अर्थ के साथ साझा किया जाता है। </li>
                                                    <li>तिमाही समाचार पत्र का हिंदी और अंग्रेजी में(द्विभाषी) प्रकाशन</li>
                                                    <li>"लीला राजभाषा" ऐप के बारे में जागरूकता उत्पन्न करना</li>
                                                                                              
                                                 
                                                </ol>
                                                
                                                     
                                                </div>
                                            </div>
                                        </div>
                                        {/* Index2 ---------------------- end */}
                                        {/* Index3 ----------------------- start*/}
                                        <div className="card">
                                            <div className="card-header">
                                                <h2 className="mb-0">
                                                    <button  className={`faq-btn${activeIndex === 3 ? '' : ' collapsed'}`} type="button" data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse3`}
                                                        onClick={() => handleToggle(3)} >
                                                        <h4>सन्देश</h4>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div id={`collapse3`}
                                                className={`collapse${activeIndex === 3 ? ' show' : ''}`} 
                                                data-bs-parent="#accordionExample">
                                                <div className="card-body">
                                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                    <td>
                                    <strong>शीर्षक</strong>
                                    </td>
                                    <td>
                                    <strong>डाउनलोड </strong>
                                    </td>
                                    </tr>
                                    <tr>
                                    <td>
                                    <strong>हिन्दी दिवस-2022 के अवसर पर माननीय गृहमंत्री जी का सन्देश </strong>
                                    </td>
                                    <td>
                                    <Link className="c-link" to={"https://www.youtube.com/watch?v=fy34EyROz1E"} target='_blank'>वीडियो </Link>
                                    
                                    </td>
                                    </tr>
                                    <tr>
                                    
                                    <td>
                                    <strong> हिन्दी दिवस-2021 के अवसर पर माननीय गृहमंत्री जी का सन्देश </strong>
                                    
                                    </td>
                                    <td>
                                    <Link className="c-link" to={"https://files.iittp.ac.in/pdfs/hindi-cell/संदेश.pdf"} target='_blank'>पी डी एफ </Link>
                                    
                                    </td>
                                    </tr>
                                    
                                    </tbody>
                                </table>
                                                </div>
                                            </div>
                                        </div>
                                        {/*Index3 -------------end */}
                                        {/*Index5---------------start*/}
                                        <div className="card">
                                            <div className="card-header">
                                                <h2 className="mb-0">
                                                    <button  className={`faq-btn${activeIndex === 4 ? '' : ' collapsed'}`} type="button" data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse4`}
                                                        onClick={() => handleToggle(4)} >
                                                        <h4>संस्थान की राजभाषा प्रकोष्ठ की तिमाही रिपोर्ट</h4>
                                                        

                                                    </button>
                                                </h2>
                                            </div>
                                            <div id={`collapse4`}
                                                className={`collapse${activeIndex === 4 ? ' show' : ''}`} 
                                                data-bs-parent="#accordionExample">
                                                <div className="card-body">
                                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                    <td>
                                    <strong>शीर्षक</strong>
                                    </td>
                                    <td>
                                    <strong>डाउनलोड </strong>
                                    </td>
                                    </tr>
                                    <tr>
                                    <td>
                                    <strong>तिमाही प्रगति रिपोर्ट की ऑनलाइन प्रस्तुति संबंधी प्रयोगकर्ता नियम पुस्तिका  </strong>
                                    </td>
                                    <td>
                                    <Link className="c-link" to={"https://files.iittp.ac.in/pdfs/hindi-cell/QPRUserManual-Hindi.pdf"} target='_blank'>पी डी एफ </Link>
                                    </td>
                                    </tr>
                                    <tr>
                                    <td>
                                    <strong> जून 2021 को समाप्त अवधि के लिए राजभाषा हिन्दी के प्रयोग संबंधी तिमाही प्रगति रिपोर्ट भाग-I </strong>
                                    </td>
                                    <td>
                                    <Link className="c-link" to={"https://files.iittp.ac.in/pdfs/hindi-cell/ति_प्र_रि_जून_2021-22_की_रिपोर्ट.pdf"} target='_blank'>पी डी एफ </Link>
                                    </td>
                                    </tr>
                                    <tr>
                                    <td>
                                    <strong> दिसंबर 2021 को समाप्त अवधि के लिए राजभाषा हिन्दी के प्रयोग संबंधी तिमाही प्रगति रिपोर्ट भाग-I  </strong>
                                    </td>
                                    <td>
                                    <Link className="c-link" to={"https://files.iittp.ac.in/pdfs/hindi-cell/QE_December_2021_Report.pdf"} target='_blank'>पी डी एफ </Link>
                                    </td>
                                    </tr>
                                    <tr>
                                    <td>
                                    <strong> मार्च 2022 को समाप्त अवधि के लिए राजभाषा हिन्दी के प्रयोग संबंधी तिमाही प्रगति रिपोर्ट भाग-I एवं II  </strong>
                                    </td>
                                    <td>
                                    <Link className="c-link" to={"https://files.iittp.ac.in/pdfs/hindi-cell/QE_March_2022_Part_I_and_II.pdf"} target='_blank'>पी डी एफ </Link>
                                    </td>
                                    </tr>
                                    <tr>
                                    <td>
                                    <strong> जून 2022 को समाप्त अवधि के लिए राजभाषा हिन्दी के प्रयोग संबंधी तिमाही प्रगति रिपोर्ट भाग-I  </strong>
                                    </td>
                                    <td>
                                    <Link className="c-link" to={"https://files.iittp.ac.in/pdfs/hindi-cell/Qpr_June_2022.pdf"} target='_blank'>पी डी एफ </Link>
                                    </td>
                                    </tr>
                                    </tbody>
                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        {/*Index5 --------------- end*/}
                                         {/*Index6---------------start*/}
                                         <div className="card">
                                            <div className="card-header">
                                                <h2 className="mb-0">
                                                    <button  className={`faq-btn${activeIndex === 5 ? '' : ' collapsed'}`} type="button" data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse5`}
                                                        onClick={() => handleToggle(5)} >
                                                        <h4>राजभाषा कार्यान्वयन समिति</h4>
                                                        

                                                    </button>
                                                </h2>
                                            </div>
                                            <div id={`collapse5`}
                                                className={`collapse${activeIndex === 5 ? ' show' : ''}`} 
                                                data-bs-parent="#accordionExample">
                                                <div className="card-body">
                                                <ol className="list-group list-group-numbered"                              
                                        style={{ textAlign: 'justify', fontSize: '12pt' }}>
                                                      <li>प्रो. के एन सत्यनारायण, निदेशक - अध्यक्ष</li>
                                                      {/* <li>श्री सुमित कुमार बिस्वास, कुल सचिव - सदस्य</li> */}
                                                        <li>श्री वेंकटरमणा बदर्ला, प्रभारी कुल सचिव - सदस्य</li>
                                                        <li>डॉ प्रभा शंकर द्विवेदी सहायक प्राध्यापक, मानविकी और सामाजिक विज्ञान विभाग - सदस्य</li>
                                                        <li>डॉ वनीत कश्यप सहायक प्राध्यापक मानविकी और सामाजिक विज्ञान विभाग - सदस्य</li>
                                                        <li>श्री चमन मेहता, उप कुल सचिव/प्रशा - सदस्य</li>
                                                        <li>श्री संतोष कुमार साहू उप कुल सचिव/स्थापना & क्रय - सदस्य</li>
                                                        <li>श्री एल राजन बाबू, उप कुल सचिव/वित्त & लेखा - सदस्य</li>
                                                        <li>श्री उमेश कुमार सिंह, सहायक कुल सचिव -- सदस्य सचिव </li>
                                                        <li>सी। विजयलक्ष्मी, हिन्दी कंसल्टेंट -- सदस्य</li>

                                                     
                                                    </ol>
                                                </div>
                                            </div>
                                        </div>
                                        {/*Index6 --------------- end*/}
                                         {/*Index7---------------start*/}
                                         <div className="card">
                                            <div className="card-header">
                                                <h2 className="mb-0">
                                                    <button  className={`faq-btn${activeIndex === 6 ? '' : ' collapsed'}`} type="button" data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse6`}
                                                        onClick={() => handleToggle(6)} >
                                                        <h4>बैठकों के कार्यवृत्त</h4>
                                                        

                                                    </button>
                                                </h2>
                                            </div>
                                            <div id={`collapse6`}
                                                className={`collapse${activeIndex === 6 ? ' show' : ''}`} 
                                                data-bs-parent="#accordionExample">
                                                <div className="card-body">
                                                <table className="table table-striped">
                                                <tbody>
                                                <tr>
                                                <td>
                                                <strong>शीर्षक</strong>
                                                </td>
                                                <td>
                                                <strong>डाउनलोड </strong>
                                                </td>
                                                </tr>
                                                <tr>
                                                <td>
                                                <strong>राजभाषा कार्यान्वयन समिति की बैठक: 01/2022-23 </strong>
                                                </td>
                                                <td>
                                                <Link className="c-link" to={"https://files.iittp.ac.in/pdfs/hindi-cell/राजभाषा_कार्यान्वयन_समिति_की_बैठक_012022-23.pdf"} target='_blank'>पी डी एफ </Link>
                                                </td>
                                                </tr>
                                                <tr>
                                                <td>
                                                <strong> राजभाषा कार्यान्वयन समिति की बैठक: 02/2022-23  </strong>
                                                </td>
                                                <td>
                                                <Link className="c-link" to={"https://files.iittp.ac.in/pdfs/hindi-cell/राजभाषा_कार्यान्वयन_समिति_की_बैठक_022022-23.pdf"} target='_blank'>पी डी एफ </Link>
                                                </td>
                                                </tr>
                                                </tbody>
                                                </table>
                                                </div>
                                            </div>
                                        </div>
                                        {/*Index7 --------------- end*/}
                                         {/*Index8---------------start*/}
                                         <div className="card">
                                            <div className="card-header">
                                                <h2 className="mb-0">
                                                    <button  className={`faq-btn${activeIndex === 7 ? '' : ' collapsed'}`} type="button" data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse7`}
                                                        onClick={() => handleToggle(7)} >
                                                        <h4>हिंदी गतिविधियाँ</h4>
                                                        

                                                    </button>
                                                </h2>
                                            </div>
                                            <div id={`collapse7`}
                                                className={`collapse${activeIndex === 7 ? ' show' : ''}`} 
                                                data-bs-parent="#accordionExample">
                                                <div className="card-body">
                                                    <Col md={12} className='c-right c-lineheight2dot5 text-dark'>

                            
                                                        <h4 className='c-headline mb-3'>हिन्दी पखवाड़े/कार्यशाला में भाग लेते हुए संस्थान के कर्मचारियों/छात्रों का उत्साह</h4>                          
                                                        <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                            {Hindi.map((item, Index) => (
                                                                <div className="grid-item financial col-3 mt-3" key={Index}>                        
                                                                        <figure className="gallery-image">
                                                                            <img src={item.img} alt="img" className="img" />
                                                                        </figure>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        </Col>
                                                </div>
                                            </div>
                                        </div>
                                        {/*Index8 --------------- end*/}
                                         {/*Index9---------------start*/}
                                         <div className="card">
                                            <div className="card-header">
                                                <h2 className="mb-0">
                                                    <button  className={`faq-btn${activeIndex === 8 ? '' : ' collapsed'}`} type="button" data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse8`}
                                                        onClick={() => handleToggle(8)} >
                                                        <h4>राजभाषा नीति</h4>
                                                        

                                                    </button>
                                                </h2>
                                            </div>
                                            <div id={`collapse8`}
                                                className={`collapse${activeIndex === 8 ? ' show' : ''}`} 
                                                data-bs-parent="#accordionExample">
                                                <div className="card-body">
                                                <table className="table table-striped">
                                                <tbody>
                                                <tr>
                                                <td>
                                                <strong>शीर्षक</strong>
                                                </td>
                                                <td>
                                                <strong>डाउनलोड </strong>
                                                </td>
                                                </tr>
                                                <tr>
                                                <td>
                                                <strong>राजभाषा अधिनियम 1963  </strong>
                                                </td>
                                                <td>
                                                <Link className="c-link" to={"https://files.iittp.ac.in/pdfs/hindi-cell/RajbhashaAdhiniyam.pdf"} target='_blank'>पी डी एफ </Link>
                                                </td>
                                                </tr>
                                                <tr>
                                                <td>
                                                <strong> राजभाषा नियम 1976   </strong>
                                                </td>
                                                <td>
                                                <Link className="c-link" to={"https://files.iittp.ac.in/pdfs/hindi-cell/राजभाषा-नियम-1976.pdf"} target='_blank'>पी डी एफ </Link>
                                                </td>
                                                </tr>
                                                <tr>
                                                <td>
                                                <strong> राजभाषा अधिनियम 1963 & राजभाषा नियम 1976 (अंग्रेजी पाठ)    </strong>
                                                </td>
                                                <td>
                                                <Link className="c-link" to={"https://files.iittp.ac.in/pdfs/hindi-cell/OFFICIAL LANGUAGE ACTS AND RULES.pdf"} target='_blank'>पी डी एफ </Link>
                                                </td>
                                                </tr>
                                                </tbody>
                                                </table>
                                                </div>
                                            </div>
                                        </div>
                                        {/*Index9 --------------- end*/}
                                         {/*Index10---------------start*/}
                                         <div className="card">
                                            <div className="card-header">
                                                <h2 className="mb-0">
                                                    <button  className={`faq-btn${activeIndex === 9 ? '' : ' collapsed'}`} type="button" data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse9`}
                                                        onClick={() => handleToggle(9)} >
                                                        <h4>वार्षिक कार्यक्रम</h4>
                                                        

                                                    </button>
                                                </h2>
                                            </div>
                                            <div id={`collapse9`}
                                                className={`collapse${activeIndex === 9 ? ' show' : ''}`} 
                                                data-bs-parent="#accordionExample">
                                                <div className="card-body">
                                                <table className="table table-striped">
                                                <tbody>
                                                <tr>
                                                <td>
                                                <strong>शीर्षक</strong>
                                                </td>
                                                <td>
                                                <strong>डाउनलोड </strong>
                                                </td>
                                                </tr>
                                                <tr>
                                                <td>
                                                <strong>वार्षिक कार्यक्रम वर्ष : 2022-2023   </strong>
                                                </td>
                                                <td>
                                                <Link className="c-link" to={"https://files.iittp.ac.in/pdfs/hindi-cell/ap_2022_23.pdf"} target='_blank'>पी डी एफ </Link>
                                                </td>
                                                </tr>
                                                </tbody>
                                                </table>
                                                </div>
                                            </div>
                                        </div>
                                        {/*Index10 --------------- end*/}
                                         {/*Index11---------------start*/}
                                         <div className="card">
                                            <div className="card-header">
                                                <h2 className="mb-0">
                                                    <button  className={`faq-btn${activeIndex === 10 ? '' : ' collapsed'}`} type="button" data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse10`}
                                                        onClick={() => handleToggle(10)} >
                                                        <h4>सुविचार</h4>
                                                        

                                                    </button>
                                                </h2>
                                            </div>
                                            <div id={`collapse10`}
                                                className={`collapse${activeIndex === 10 ? ' show' : ''}`} 
                                                data-bs-parent="#accordionExample">
                                                <div className="card-body">
                                                <ol className="list-group list-group-numbered"                              
                                        style={{ textAlign: 'justify', fontSize: '12pt' }}>
                                                      <li>"राष्ट्रभाषा के बिना आजादी बेकार है।" - अवनींद्रकुमार विद्यालंकार।</li>
                                                        <li>"विदेशी भाषा का किसी स्वतंत्र राष्ट्र के राजकाज और शिक्षा की भाषा होना सांस्कृतिक दासता है।" - वाल्टर चेनिंग।</li>
                                                        <li>"राष्ट्रभाषा हिंदी का किसी क्षेत्रीय भाषा से कोई संघर्ष नहीं है।" - अनंत गोपाल शेवड़े।</li>
                                                        <li>"इस विशाल प्रदेश के हर भाग में शिक्षित-अशिक्षित, नागरिक और ग्रामीण सभी हिंदी को समझते हैं।" - राहुल सांकृत्यायन।</li>
                                                        <li>"जब से हमने अपनी भाषा का समादर करना छोड़ा तभी से हमारा अपमान और अवनति होने लगी।" - (राजा) राधिकारमण प्रसाद सिंह।</li>
                                                        <li>"संस्कृत मां, हिंदी गृहिणी और अंग्रेजी नौकरानी है।" - डॉ. फादर कामिल बुल्के।</li>
                                                        <li>"हिंदी चिरकाल से ऐसी भाषा रही है जिसने मात्र विदेशी होने के कारण किसी शब्द का बहिष्कार नहीं किया।" - राजेंद्रप्रसाद।</li>
                                                        <li>"जिस देश को अपनी भाषा और अपने साहित्य के गौरव का अनुभव नहीं है, वह उन्नत नहीं हो सकता।" - देशरत्न डॉ. राजेन्द्रप्रसाद।</li>
                                                        <li>"तलवार के बल से न कोई भाषा चलाई जा सकती है न मिटाई।" - शिवपूजन सहाय।</li>
                                                        <li>"लाखों की संख्या में छात्रों की उस पलटन से क्या लाभ जिनमें अंग्रेजी में एक प्रार्थनापत्र लिखने की भी क्षमता नहीं है।"- कंक।</li>
                                                        <li>"हिंदी भाषी ही एक ऐसी भाषा है जो सभी प्रांतों की भाषा हो सकती है।" - पं. कृ. रंगनाथ पिल्लयार।</li>
                                                        <li>"क्या संसार में कहीं का भी आप एक दृष्टांत उद्धृत कर सकते हैं जहाँ बालकों की शिक्षा विदेशी भाषाओं द्वारा होती हो।" - डॉ. श्यामसुंदर दास।</li>
                                                        <li>"किसी देश में ग्रंथ बनने तक वैदेशिक भाषा में शिक्षा नहीं होती थी। देश भाषाओं में शिक्षा होने के कारण स्वयं ग्रंथ बनते गए हैं। - साहित्याचार्य रामावतार शर्मा।</li>
                                                        <li>"जो भाषा सामयिक दूसरी भाषाओं से सहायता नहीं लेती वह बहुत काल तक जीवित नहीं रह सकती।" - पांडेय रामवतार शर्मा।</li>
                                                        <li>"आप जिस तरह बोलते हैं, बातचीत करते हैं, उसी तरह लिखा भी कीजिए। भाषा बनावटी न होनी चाहिए।" - महावीर प्रसाद द्विवेदी।</li>

                                                     
                                                    </ol>
                                                </div>
                                            </div>
                                        </div>
                                        {/*Index11 --------------- end*/}
                                         {/*Index12---------------start*/}
                                         <div className="card">
                                            <div className="card-header">
                                                <h2 className="mb-0">
                                                    <button  className={`faq-btn${activeIndex === 11 ? '' : ' collapsed'}`} type="button" data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse11`}
                                                        onClick={() => handleToggle(11)} >
                                                        <h4>गैलरी</h4>
                                                        

                                                    </button>
                                                </h2>
                                            </div>
                                            <div id={`collapse11`}
                                                className={`collapse${activeIndex === 11 ? ' show' : ''}`} 
                                                data-bs-parent="#accordionExample">
                                                <div className="card-body">
                                                <Col md={12} className='c-right c-lineheight2dot5 text-dark'>
                                                    <h4 className='c-headline mb-3'>हिन्दी पखवाड़ा प्रोग्राम फ़ोटोज़</h4>                          
                                                    <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                        {Gallery.map((item, Index) => (
                                                            <div className="grid-item financial col-3 mt-3" key={Index}>                        
                                                                    <figure className="gallery-image">
                                                                        <img src={item.img} alt="img" className="img" />
                                                                    </figure>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    </Col>
                                                </div>
                                            </div>
                                        </div>
                                        {/*Index42--------------- end*/}
                                         {/*Index13---------------start*/}
                                         <div className="card">
                                            <div className="card-header">
                                                <h2 className="mb-0">
                                                    <button  className={`faq-btn${activeIndex === 12 ? '' : ' collapsed'}`} type="button" data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse12`}
                                                        onClick={() => handleToggle(12)} >
                                                        <h4>हिन्दी के प्रयोग संबंधी आदेशों का संकलन</h4>
                                                        

                                                    </button>
                                                </h2>
                                            </div>
                                            <div id={`collapse12`}
                                                className={`collapse${activeIndex === 12 ? ' show' : ''}`} 
                                                data-bs-parent="#accordionExample">
                                                <div className="card-body">
                                                <table className="table table-striped">
                                                <tbody>
                                                <tr>
                                                <td>
                                                <strong>शीर्षक</strong>
                                                </td>
                                                <td>
                                                <strong>डाउनलोड </strong>
                                                </td>
                                                </tr>
                                                <tr>
                                                <td>
                                                <strong>हिन्दी के प्रयोग संबंधी आदेशों का संकलन    </strong>
                                                </td>
                                                <td>
                                                <Link className="c-link" to={"https://files.iittp.ac.in/pdfs/hindi-cell/हिन्दी के प्रयोग संबंधी आदेशों का संकलन.pdf"} target='_blank'>पी डी एफ </Link>
                                                </td>
                                                </tr>
                                                <tr>
                                                <td>
                                                <strong>राजभाषा शब्दावली    </strong>
                                                </td>
                                                <td>
                                                <Link className="c-link" to={"https://files.iittp.ac.in/pdfs/hindi-cell/राजभाषा शब्दावल.pdf"} target='_blank'>पी डी एफ </Link>
                                                </td>
                                                </tr>
                                                <tr>
                                                <td>
                                                <strong>राजभाषा के आधार पर ‘क’, ‘ख’ एंव ‘ग’ क्षेत्र के राज्यों का विवरणी    </strong>
                                                </td>
                                                <td>
                                                <Link className="c-link" to={"https://files.iittp.ac.in/pdfs/hindi-cell/राजभाषा के आधार पर ‘क’, ‘ख’ एंव ‘ग’ क्षेत्र के राज्यों का विवरण.pdf"} target='_blank'>पी डी एफ </Link>
                                                </td>
                                                </tr>
                                                </tbody>
                                                </table>
                                                </div>
                                            </div>
                                        </div>
                                        {/*Index13 --------------- end*/}
                                </div>
                            </div>
                        </div>
                    
                    </Row>

                    
                </div>
            </section>
        </>
    );
}


export default Main;